import ChargeRegister from "models/charge-register";
import { keepTwoDecimal } from "common/js/util";

export default {
  data() {
    return {
      //设置今天以后不可选
      pickerOptions: {
        //限制时间
        selectableRange: this.selectableRange(),
        // 限制日期
        disabledDate: this.disabledDate,
      },
      // 贴标服务单价列表
      stickerList: [],
      serverNameList: [],
      goodsNameList: [],
    }
  },

  watch: {
    ruleForm: {
      handler(newVal) {
        if (this.ruleForm.serviceContent == 2) {
          let num = 0
          this.ruleForm.returnGoodsInfo.map(i => {
            num += Number(i.quantity)
          })
          this.ruleForm.nums = num
        }
        this.ruleForm.amount = keepTwoDecimal(
          Number(newVal.nums) * Number(newVal.unitPrice)
        );
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
  },
  methods: {
    /**
     * @desc 获取项目名称
     * @param {*} warehouseId 仓库id
     * @param {*} type 类型 unregisteredDetails 来自补登
     * @param {*} from 来自哪里 fromUnregistered, fromBase
    */
    initProjectList(warehouseId, from ,type) {
      ChargeRegister.getProjectList(warehouseId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            obj.customerId = value.customerId;
            let bulkUnitPriceArr = []
            bulkUnitPriceArr.push({
              name: value.bulkUnitPrice
            });
            if (bulkUnitPriceArr.length === 0) {
              obj.bulkUnitPrice = [{ name: 0 }];
            } else {
              obj.bulkUnitPrice = bulkUnitPriceArr;
            }
            let unloadUnitPriceArr = []
            unloadUnitPriceArr.push({
              name: value.unloadUnitPrice
            });
            if (unloadUnitPriceArr.length === 0) {
              obj.unloadUnitPrice = [{ name: 0 }];
            } else {
              obj.unloadUnitPrice = unloadUnitPriceArr;
            }
            let refundPriceRulesArr = []
            let refundPriceRulesObj = {};
            refundPriceRulesObj.name = value.refundPriceRules.unitPrice;
            refundPriceRulesArr.push(refundPriceRulesObj);
            if (refundPriceRulesArr.length === 0) {
              obj.refundPriceRules = [{ name: 0 }];
            } else {
              obj.refundPriceRules = refundPriceRulesArr;
            }
            obj.refundPriceRules = refundPriceRulesArr;
            arr.push(obj);
          });
          this.unregisteredProjectList = arr;
          if (from === 'fromBase') {
            this.projectNameList = arr;
            if (arr.length === 0) {
              this.ruleForm.projectName = "";
              if (this.ruleForm.serviceContent !== 1) this.ruleForm.customerId = "";
              if (this.ruleForm.serviceContent === 1) this.searchForm.projectId = ""
            } else {
              let projectNameObj = arr[0]
              if (this.ruleForm.serviceContent === 1) {
                if (type !== 'unregisteredDetails') this.searchForm.projectId = arr[0].id
                this.stickerList = projectNameObj.bulkUnitPrice;
                this.ruleForm.unitPrice = projectNameObj.bulkUnitPrice[0].name
              } else if (this.ruleForm.serviceContent === 2) {
                this.stickerList = projectNameObj.refundPriceRules;
                this.ruleForm.unitPrice = projectNameObj.refundPriceRules[0].name
              }
              if (this.ruleForm.serviceContent !== 3) {
                if (type !== 'unregisteredDetails') this.ruleForm.projectName = arr[0].id;
              }
              if (this.ruleForm.serviceContent === 4) {
                this.ruleForm.customerId = arr[0].customerId
                this.initServiceLableList()
              }
            }
          } else {
            if (arr.length === 0) {
              if (this.ruleForm.serviceContent === 1) this.searchForm.projectId = ""
            } else {
              if (this.ruleForm.serviceContent === 1) {
                if (type !== 'unregisteredDetails') this.searchForm.projectId = arr[0].id
              }
            }
          }
        }
      });
    },

    /** 
     * @desc 贴标服务列表
    */
    initServiceLableList() {
      let projectId = this.ruleForm.projectName
      let data = {
        projectId
      }
      ChargeRegister.getServiceLableList(data).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.serviceName;
            obj.projectId = value.projectId;
            obj.unitPrice = value.unitPrice;
            arr.push(obj);
          });
          this.serverNameList = arr;
        } else {
          this.$message.error(res.message)
        }
      });
    },

    /** 
     * @desc 获取商品名称列表
    */
    initGoodsName(code) {
      let customerId = this.ruleForm.customerId
      ChargeRegister.getGoodsName(code, customerId).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.name = i
            arr.push(obj)
          })
          this.goodsNameList = arr
          if (this.goodsNameList.length) this.ruleForm.goodsName = this.goodsNameList[0].name
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @description 根据选中仓库获取项目
     * @param {*} type 类型 unregisteredDetails 来自补登
    */
    changeWarehouse(type) {
      let warehouseId = this.ruleForm.warehouseId;
      this.initProjectList(warehouseId, 'fromBase' ,type);
      if (this.ruleForm.serviceContent === 1) this.searchForm.warehouseId = warehouseId
      if (this.ruleForm.serviceContent === 3) this.clearPrice()
    },

    changeUnregisteredWarehouse() {
      this.initProjectList(this.searchForm.warehouseId, 'fromUnregistered');
    },

    changeProjectName() {
      if (this.ruleForm.serviceContent === 4) {
        this.ruleForm.serverName = null
        this.initServiceLableList()
      }
      let obj = this.projectNameList.find(item => { return item.id == this.ruleForm.projectName })
      if (this.ruleForm.serviceContent !== 1) {
        this.ruleForm.customerId = obj.customerId
      }
      if (this.ruleForm.serviceContent === 1) {
        this.unregisteredProjectList = this.projectNameList
        this.searchForm.projectId = this.ruleForm.projectName
        this.searchForm.warehouseId = this.ruleForm.warehouseId
        this.stickerList = obj.bulkUnitPrice;
        this.ruleForm.unitPrice = obj.bulkUnitPrice[0].name
      }
      if (this.ruleForm.serviceContent === 3) this.findUnitPriceByProjectId()
    },

    /** 
     * @desc 清出单价
    */
    clearPrice() {
      this.stickerList = []
      this.ruleForm.projectName = null
      this.ruleForm.unitPrice = null
    },

    /** 
     * @desc 根据项目id筛选单价
    */
    findUnitPriceByProjectId() {
      let obj = this.projectNameList.find(item => { return item.id == this.ruleForm.projectName })
      this.stickerList = obj.unloadUnitPrice;
      this.ruleForm.unitPrice = obj.unloadUnitPrice[0].name
    },

    selectableRange() {
      let date = new Date();
      let hour = date.getHours();
      hour = hour > 9 ? hour : "0" + hour;
      let minute = date.getMinutes();
      minute = minute > 9 ? minute : "0" + minute;
      let second = date.getSeconds();
      second = second > 9 ? second : "0" + second;
      let time = `${hour}:${minute}:${second}`;
      const selectableRange = `${time}-23:59:59`;
      return selectableRange;
    },

    disabledDate(date) {
      //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      return date.getTime() > Date.now();
    },
  }
}